import { Pipe, PipeTransform } from "@angular/core";
import { IObservationDefinition, ITranslation } from "@comunicare/comunicare-interfaces";

@Pipe({ name: "getEffectiveTiming" })
export class GetEffectiveTimingPipe implements PipeTransform {
  transform(effectiveTimingCode: string, ObservationDefinition: IObservationDefinition): ITranslation {
    return ObservationDefinition?.lsTimingWhen?.find((el) => el.when.code === effectiveTimingCode)?.name;
  }
}
